const { PLAID_ENV, BUILD_MODE } = require('../env');

// CJS format required to reference from next.config.js
module.exports.isProduction = PLAID_ENV === 'production';
module.exports.isDevelopment = PLAID_ENV === 'development';
module.exports.isTesting = ['testing', 'AUTOBUILDNEXT', 'storybook'].includes(
  PLAID_ENV,
);
module.exports.isPreview = true;
module.exports.isServerBuild = BUILD_MODE === 'server';
module.exports.isStaticBuild = BUILD_MODE === 'static';
